import { HttpClient } from '@/data/protocols/http'
import { AccountChangeLanguage } from '@/domain/usecases/account/account-change-language'
import { GenericResponse } from '@/infra/http'
import { BaseRemote } from '../base-remote'

export class RemoteAccountChangeLanguage extends BaseRemote implements AccountChangeLanguage {
  constructor(
    protected readonly url: string,
    protected readonly httpClient: HttpClient<GenericResponse<RemoteAccountChangeLanguage.Model>>
  ) {
    super()
  }

  async change(request: AccountChangeLanguage.RequestModel): Promise<void> {
    const response = await this.httpClient.request({
      url: this.url,
      method: 'patch',
      body: request
    })

    return this.onSuccess(response)
  }
}

export namespace RemoteAccountChangeLanguage {
  export type Model = void
}
